import React, { useCallback, useEffect, useMemo, useState } from "react";
import { User } from "../../../../imsdk/db/t_user";
import * as ImSdk from "../../../../imsdk/api";
import { currentRealm } from "../../../realm";
import { CHAT_LIST, ChatListSchema } from "../../../realm/schema";
import {
  Image,
  Modal,
  Platform,
  Pressable,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { postJson } from "../../../net/http";
import { ChatDetailUser } from "../components/ChatDetailUser";
import { color_999999, white } from "../../../assets/style/colors";
import { CommonSetting } from "../../../components/setting/CommonSetting";
import { BottomButtonView } from "../../../components/BottomButtonView";
import {
  ChatDetailProps,
  handleMuteTopic,
  handleToTopTopic,
  singleStyles,
} from "../ChatDetail";
import { showDialog, showMsgDialog } from "../../../components/CommonDialog";
import { showToast } from "../../../components/Toast";
import { reload, useChatStore } from "../../../store/ChatStore";
import { useStore } from "../../../store/UserStore";
import { hideLoading, showLoading } from "../../../components/Loading";
import {
  Str_Album,
  Str_Camera,
  Str_Cancel,
  Str_ChatDetail,
  Str_ChatTop,
  Str_ClearChatHistory,
  Str_DelGroup,
  Str_DelMemberTip,
  Str_DelMemberTip1,
  Str_GroupAnnouncement,
  Str_GroupAvatar,
  Str_GroupDisbanded,
  Str_GroupManagement,
  Str_GroupName,
  Str_GroupQrCode,
  Str_ImgUploadFail,
  Str_ImgUploading,
  Str_MsgNotification,
  Str_MyNickname,
  Str_NotInGroup,
  Str_OnlyGroupAdminCanEdit,
  Str_Remarks,
  Str_Report,
  Str_SearchChatContent,
  Str_ViewAllMembers,
} from "../../../language/string_res";
import {
  openCamera,
  openSinglePicker,
  PickerResult,
} from "../../../utils/PicOrCameraManager";
import { CommonBottomModal } from "../../CommonBottomModal";
import { Msg } from "../../../../imsdk/db/t_msg";
import { uploadImages } from "../../../utils/upload";
import { LeftView } from "../CListItem";
import { CleanHistoryModal } from "../CleanHistoryModal";
import { RemarkType } from "../../Mine/MineRemark";
import AddIcon from "../../../assets/svg/icon_add_user.svg";
import RemoveIcon from "../../../assets/svg/icon_reduce.svg";
import { GroupManagerModal } from "./GroupManager";
import globalEventBus from "../../../utils/EventBus";
import { UploadKey } from "../../../utils/ReactBlobUtil";
import { use } from "i18next";

type DtailState = {
  avatar?: string;
  uploadImageVis: boolean;
  remarkType?: RemarkType;
  currentRemark?: string;
  cleanVisible: boolean;
  isMute: boolean;
  isTop: boolean;
};
export const GroupChatDetail = ({ navigation }: ChatDetailProps) => {
  const { chatState, chatDispatch } = useChatStore();
  const { state, dispatch } = useStore();
  const { curTopicWithSummary, isAdmin } = chatState;
  const group = curTopicWithSummary.group;
  const topic = chatState.curTopicWithSummary.topic;

  useEffect(() => {
    console.log('[GroupChatDetail] chatState.isAdmin ', chatState.isAdmin);
  }, [state]);

  const [detailState, setDetailState] = useState<DtailState>({
    avatar: group?.avatar,
    uploadImageVis: false,
    cleanVisible: false,
    isMute: topic.mute,
    isTop: topic.order > 0,
  });
  const [showGroupManager, setShowGroupManager] = useState(false);

  // 监听 topic 变化，同步更新状态
  useEffect(() => {
    setDetailState({
      avatar: group?.avatar,
      uploadImageVis: false,
      cleanVisible: false,
      isMute: topic.mute,
      isTop: topic.order > 0,
    });
  }, [topic.tid, topic.mute, topic.order, group?.avatar]);

  // 移除 useState 和 useEffect，改用 useMemo
  const visibleUsers = useMemo(() => {
    const users = chatState.curTopicWithSummary?.users ?? [];
    if (users.length > 13) {
      return users.slice(0, 13)
    } else {
      return users
    }
  }, [chatState.curTopicWithSummary?.users]);

  const im = ImSdk.getInstance();
  const currentUid = im.CurrentUid();

  const handleClose = () => {
    setDetailState({ ...detailState, uploadImageVis: false });
  };

  const setIsTop = (isTop: boolean) => {
    setDetailState({ ...detailState, isTop: isTop });
    const topicWithSummary = chatState.curTopicWithSummary;
    topicWithSummary.topic.order = isTop ? 1 : 0;
    chatDispatch({ type: "CHAT_UPDATE_TOPIC", payload: topicWithSummary });
  };

  const setIsMute = (isMute: boolean) => {
    console.log('[GroupChatDetail] setIsMute 被调用:', {
      newValue: isMute,
      oldValue: detailState.isMute,
      topicMute: topic.mute
    });
    setDetailState({ ...detailState, isMute: isMute });
    const topicWithSummary = chatState.curTopicWithSummary;
    topicWithSummary.topic.mute = isMute;
    chatDispatch({ type: "CHAT_UPDATE_TOPIC", payload: topicWithSummary });
  };

  function nativeToChatUsers() {
    if (group && group.tid) {
      navigation.navigate("GroupUserList", {
        isSearch: false,
        tid: group.tid,
        isAdmin: isAdmin,
      });
    }
  }

  function handleQuitGroup() {
    function quit() {
      currentRealm().objectForPrimaryKey(CHAT_LIST, topic.tid).then(async (currChat) => {
        //TODO: 查出来的currChat=null
        if (currChat) {
          await currentRealm().write(async () => {
            currChat.isQuit = true;
            await currentRealm().create(CHAT_LIST, currChat);
          });
          dispatch({
            type: "UPDATE_CHAT_LIST_ITEM",
            payload: {
              tid: currChat.tid,
              chat: currChat,
            },
          });
        }
        cleanMsg().then();
      });
    }

    const cleanMsg = async () => {
      showLoading();
        const res = await postJson<{ msgs?: Msg[] }>("/v1/sdk/msg/history", {
        body: {
          tid: topic.tid,
          size: 1,
          containMax: true,
        },
      });
      const promises: Promise<any>[] = [];
      const im = ImSdk.getInstance();
      promises.push(im.DelTopic(topic.tid));
      if (res && res.data && res.data.msgs && res.data.msgs.length > 0) {
        const msg = res.data.msgs[0];
        promises.push(im.CleanMsg(topic.tid, msg.mid));
      }

      Promise.all(promises)
        .then((r) => {
          const res = r[0];
          if (res.code === 0) {
            dispatch({ type: "EXIT_GROUP", payload: { tid: topic.tid } });
          }
          if (r.length === 2) {
            const value = r[1];
            if (value.code != -1) {
              chatDispatch({
                type: "CHAT_CLEAN_MSG",
                payload: { tid: topic.tid },
              });
              dispatch({ type: "CLEAN_MSG", payload: topic.tid });
            }
          }
        })
        .finally(() => {
          hideLoading();
          // 退出群聊后，通知第三栏关闭聊天面板和详情
          globalEventBus.emit("CloseChatPanel", { tid: topic.tid });
          globalEventBus.emit("ClearWebDetail", {});
          navigation.navigate("MainTab");
        });
    };

    const b = group?.uid === currentUid;
    const tip = b && group?.flag !== 2 ? Str_DelMemberTip : Str_DelMemberTip1;
      const url = b ? "/v1/sdk/group/delete" : "/v1/sdk/group/quit";
    const body = { tid: topic.tid };
    if (group?.flag === 2) {
      postJson(url, { body: body }).then((res) => {
        if (res.code === 0) {
          quit();
        }
      });
      return;
    }
    showDialog({
      message: tip,
      cancelText: Str_Cancel,
      onConfirm: () => {
        postJson(url, { body: body }).then((res) => {
          if (res.code === 0) {
            quit();
          }
        });
      },
    });
  }

  const openPicker = useCallback(() => {
    openSinglePicker("photo")
      .then((r) => {
        if (r) {
          uploadImage(r);
        }
      })
      .catch((error) => {
        console.error("[GroupChatDetail] openPicker 失败:", error);
      })
      .finally(() => {
        handleClose();
      });
  }, []);
  const openTake = useCallback(() => {
    openCamera("photo")
      .then((r) => {
        if (r) {
          uploadImage(r);
        }
      })
      .finally(() => {
        handleClose();
      });
  }, []);
  const uploadImage = (result: PickerResult) => {
    showLoading(Str_ImgUploading);
    uploadImages([result], UploadKey.Profile)
      .then((r) => {
        if (r.responses && r.responses.length > 0) {
          const data = r.responses[0];
          updateImage(data.url);
        } else {
          console.warn("[GroupChatDetail] 上传失败：响应为空");
          showToast(Str_ImgUploadFail);
        }
      })
      .catch((error) => {
        console.error("[GroupChatDetail] uploadImages 失败:", error);
        showToast(Str_ImgUploadFail);
      })
      .finally(() => {
        hideLoading();
      });
  };

  const updateImage = (url: string) => {
      postJson<any>(`/v1/sdk/group/profile/set`, {
      body: { avatar: url, tid: topic.tid },
    })
      .then((res) => {
        if (res.code === 0) {
          setDetailState({ ...detailState, avatar: url });
          reload(topic.tid, chatDispatch);
        } else {
          showToast(res.msg || Str_ImgUploadFail);
        }
      })
      .finally(() => {
        hideLoading();
      });
  };

  const checkInGroup = () => {
    const uid = ImSdk.getInstance().CurrentUid();
    return (
      chatState.curTopicWithSummary.users?.map((v) => v.uid)?.includes(uid) ===
      true
    );
  };

  const navMineRemark = (type: RemarkType, currentRemark?: string) => {
    navigation.navigate("MineRemark", {
      id: topic.tid,
      type: type,
      currentValue: currentRemark,
    });
  };

  return (
    <View style={{ flex: 1, backgroundColor: white }}>
      {/* 聊天详情标题栏 */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          padding: 15,
          borderBottomWidth: 1,
          borderBottomColor: "#f0f0f0",
          backgroundColor: white,
        }}
      >
        <Text
          style={{ flex: 1, fontSize: 18, fontWeight: "bold", color: "#333" }}
        >
          聊天详情
        </Text>
        <TouchableOpacity
          onPress={() => {
            // 触发关闭侧边栏事件
            globalEventBus.emit("ShowWebDetail", { screenName: "ChatList" });
          }}
          style={{ padding: 5 }}
        >
          <Text style={{ fontSize: 28, color: "#666", lineHeight: 28 }}>×</Text>
        </TouchableOpacity>
      </View>
      <ScrollView>
        <View style={{}}>
          {group?.flag !== 2 && (
            <View style={[singleStyles.userCard]}>
              <View
                style={{
                  flexDirection: "row",
                  flexWrap: "wrap",
                  paddingHorizontal: 10,
                  width: "100%",
                }}
              >
                {visibleUsers.map((user) => (
                  <ChatDetailUser
                    style={singleStyles.chatItem}
                    user={user as any as User}
                    key={user.uid}
                    action={(user) => {
                      if (group?.group_allow_member_visit !== "1" && !isAdmin) {
                        return;
                      }
                      navigation.navigate("ContactInfoModeal", {
                        current: user,
                      });
                    }}
                  />
                ))}
                {/*只有管理员，或者打开了普通成员能够邀请开关才可见*/}
                {(isAdmin || group?.group_friend_invite_enter === "1") && (
                  <Pressable
                    style={singleStyles.chatItem}
                    onPress={() => {
                      if (checkInGroup()) {
                        navigation.navigate("GroupRemoveOrAddUser", {
                          isRemove: false,
                        });
                      } else {
                        showToast(Str_NotInGroup);
                      }
                    }}
                  >
                    <AddIcon width={50} height={50} />
                  </Pressable>
                )}

                {isAdmin && (
                  <Pressable
                    style={singleStyles.chatItem}
                    onPress={() => {
                      if (checkInGroup()) {
                        navigation.navigate("GroupRemoveOrAddUser", {
                          isRemove: true,
                        });
                      } else {
                        showToast(Str_NotInGroup);
                      }
                    }}
                  >
                    <RemoveIcon width={50} height={50} />
                  </Pressable>
                )}
              </View>
              {(isAdmin || group?.group_allow_member_list === "1") && (
                <Pressable
                  style={{
                    marginTop: 16,
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                  onPress={nativeToChatUsers}
                >
                  <Text style={{ fontSize: 13, color: color_999999 }}>
                    {Str_ViewAllMembers}
                  </Text>
                  <Image
                    style={{ width: 6, height: 11, marginStart: 4 }}
                    source={require("../../../assets/image/icon_right_arrow.png")}
                  />
                </Pressable>
              )}
            </View>
          )}

          <CommonSetting
            style={{ marginTop: 20, borderRadius: 0 }}
            itemOption={[
              {
                text: Str_GroupAvatar,
                rightType: "Back",
                onClick: () => {
                  if (group?.flag === 2) {
                    showToast(Str_GroupDisbanded);
                    return;
                  }
                  // Web 上直接打开文件选择器
                  if (Platform.OS === "web") {
                    openSinglePicker("photo")
                      .then((r) => {
                        if (r) {
                          uploadImage(r);
                        }
                      })
                      .catch((error) => {
                        console.error("[GroupChatDetail] 选择图片失败:", error);
                      });
                  } else {
                    setDetailState({ ...detailState, uploadImageVis: true });
                  }
                },
                rightComponent: <LeftView left={{ name: '', avatar: detailState.avatar, uid: 0 }} size={30} isRounded={true} isGroup={true} radius={0} style={{ marginRight: 0 }} />,
              },
              {
                text: Str_GroupName,
                rightType: isAdmin ? "Back" : "None",
                rightText: group?.name || topic.name,
                onClick: () => {
                  if (group?.flag === 2) {
                    showToast(Str_GroupDisbanded);
                    return;
                  }
                  if (isAdmin) {
                    navMineRemark(
                      RemarkType.GROUP_NAME,
                      group?.name || topic.name
                    );
                  }
                },
              },
              {
                text: Str_GroupQrCode,
                rightType: "Back",
                onClick: () => {
                  if (group?.flag === 2) {
                    showToast(Str_GroupDisbanded);
                    return;
                  }
                  navigation.navigate("QRCodeScreen", { group: group });
                },
              },
              {
                text: Str_MyNickname,
                visible:
                  isAdmin ||
                  group?.group_member_alias === "1" ||
                  (chatState.inGroupRemark?.length || 0) > 0 ||
                  (state?.user.nick?.length || 0) > 0,
                rightType:
                  isAdmin || group?.group_member_alias === "1"
                    ? "Back"
                    : "None",
                rightText: chatState.inGroupRemark || state?.user.nick,
                onClick: () => {
                  if (group?.flag === 2) {
                    showToast(Str_GroupDisbanded);
                    return;
                  }
                  if (isAdmin || group?.group_member_alias === "1") {
                    navMineRemark(
                      RemarkType.GROUP_NICK,
                      chatState.inGroupRemark || state?.user.nick
                    );
                  }
                },
              },

              {
                text: Str_Remarks,
                rightType: "Back",
                onClick: () => {
                  if (group?.flag === 2) {
                    showToast(Str_GroupDisbanded);
                    return;
                  }
                  navMineRemark(RemarkType.TOPIC, group?.remark);
                },
                rightText: group?.remark,
              },

              {
                text: Str_SearchChatContent,
                rightType: "Back",
                onClick: () => {
                  if (group?.flag === 2) {
                    showToast(Str_GroupDisbanded);
                    return;
                  }
                  navigation.navigate("SearchChatResultScreen", {
                    tid: topic.tid,
                    isAdmin: isAdmin,
                  });
                },
              },
              {
                text: Str_ChatTop,
                rightType: "Switch",
                switchIsEnabled: detailState.isTop,
                switchChange: (newValue) => {
                  if (group?.flag === 2) {
                    showToast(Str_GroupDisbanded);
                    return;
                  }
                  setIsTop(newValue);
                  handleToTopTopic(topic, newValue, setIsTop);
                },
                setIsEnabled: setIsTop,
              },
              {
                text: Str_MsgNotification,
                rightType: "Switch",
                switchIsEnabled: detailState.isMute,
                setIsEnabled: setIsMute,
                switchChange: (newValue) => {
                  if (group?.flag === 2) {
                    showToast(Str_GroupDisbanded);
                    return;
                  }
                  setIsMute(newValue);
                  handleMuteTopic(topic, newValue, setIsMute);
                },
              },
              {
                text: Str_GroupAnnouncement,
                rightType: "Back",
                rightText: chatState.groupNotice,
                onClick: () => {
                  if (group?.flag === 2) {
                    showToast(Str_GroupDisbanded);
                    return;
                  }
                  //只有群主才能设置群公告
                  if (isAdmin) {
                    navigation.navigate("GroupNotice", {
                      tid: topic.tid,
                      notice: chatState.groupNotice ?? "",
                      canEdit: true,
                    });
                  } else {
                    if (chatState.groupNotice) {
                      navigation.navigate("GroupNotice", {
                        tid: topic.tid,
                        notice: chatState.groupNotice,
                        canEdit: false,
                      });
                    } else {
                      showMsgDialog(Str_OnlyGroupAdminCanEdit);
                    }
                  }
                },
              },
              {
                visible: isAdmin,
                text: Str_GroupManagement,
                rightType: "Back",
                onClick: () => {
                  if (group?.flag === 2) {
                    showToast(Str_GroupDisbanded);
                    return;
                  }
                  setShowGroupManager(true);
                },
              },
              {
                text: Str_ClearChatHistory,
                rightType: "Back",
                onClick: () => {
                  setDetailState({
                    ...detailState,
                    cleanVisible: true,
                  });
                },
              },
              {
                text: Str_Report,
                rightType: "Back",
                onClick: () => {
                  navigation.navigate("Report", { tid: topic.tid });
                },
              },
            ]}
          />
        </View>
      </ScrollView>
      <BottomButtonView text={Str_DelGroup} onClick={handleQuitGroup} />

      <CleanHistoryModal
        setVis={(vis) => setDetailState({ ...detailState, cleanVisible: vis })}
        tid={topic.tid}
        vis={detailState.cleanVisible}
      />

      <CommonBottomModal
        visible={detailState.uploadImageVis}
        text1={Str_Album}
        text2={Str_Camera}
        close={handleClose}
        click1={openPicker}
        click2={openTake}
      />

      {/* 群管理模态框 - 覆盖整个侧边栏 */}
      {showGroupManager && (
        <GroupManagerModal
          visible={showGroupManager}
          onClose={() => setShowGroupManager(false)}
          navigation={navigation}
        />
      )}
    </View>
  );
};
